import Event from 'base/event'
import Hub from 'base/hub'
import store from 'base/store'
import addScript from 'base/lib/addScript'
import 'data-layer-helper/dist/data-layer-helper'

const OneTrustEvents = {
  GENERAL: 'trackOptanonEvent',
  UPDATED: 'OneTrustGroupsUpdated',
}

const OneTrustActions = {
  OPEN: 'Preference Center Opened From Function',
  // Note that OneTrust names this event "Save" but in actuality it represents
  // a "change" of preferences in the modal, regardless of whether the user
  // actually hit the "save" button to enact the new preference choice.
  SAVE: 'Preferences Save Settings',
}

export function getIsTargettingActive() {
  // `C0004` is the label of the opt-out setting set by OneTrust–it represents
  // "Targeting Cookies"
  return window.OnetrustActiveGroups?.includes(',C0004,')
}

export default function setupOneTrust() {
  if (!store.getState().appConfig.isProductionLike) {
    return
  }

  // This variable keeps track of whether the user has selected new preferences
  // in the modal.
  let hasSelectedNewPreferences = false

  window.dataLayer ||= []

  new window.DataLayerHelper(window.dataLayer, (model, message) => {
    if (message?.event === OneTrustEvents.GENERAL) {
      if (message.optanonAction === OneTrustActions.OPEN) {
        Hub.pub(Event.OneTrust.PREFERENCES_OPENED)
      }

      if (message.optanonAction === OneTrustActions.SAVE) {
        hasSelectedNewPreferences = true
      }
    }

    if (message?.event === OneTrustEvents.UPDATED) {
      Hub.pub(Event.OneTrust.PREFERENCES_SET, {
        activeGroups: message.OnetrustActiveGroups,
        isSetManually: hasSelectedNewPreferences,
      })
      hasSelectedNewPreferences = false
    }
  })

  addScript('https://cdn.cookielaw.org/scripttemplates/otSDKStub.js', {
    async: true,
    charset: 'UTF-8',
    'data-domain-script': '76ea157b-d470-43ce-ad21-4c2b3dc6fc1c',
  })
}
